import { TokenContext, useFormContext } from 'dynamic-uniforms'
import { ComponentType, createElement, Fragment } from 'react'
import AutoField from './AutoField'
import { useCiboAutoForm } from './CiboAutoFormContext'

export type AutoFieldsProps = {
  element?: ComponentType | string
  fields?: string[]
  omitFields?: string[]
  tokenContext: TokenContext | undefined
  showInlineError?: boolean
}

export const AutoFields = ({
  element = Fragment,
  fields,
  omitFields = [],
  showInlineError,
  tokenContext,
  ...props
}: AutoFieldsProps) => {
  const { bridge } = useFormContext()
  const { warnings } = useCiboAutoForm()

  return createElement(
    element,
    props,
    (fields ?? bridge.getSubfields())
      .filter((field: string) => !omitFields.includes(field))
      .map((field: string) => {
        const props = showInlineError ? { showInlineError } : {}
        return createElement(
          AutoField,
          Object.assign({ key: field, name: field, warning: warnings?.[field], ...props })
        )
      })
  )
}
